import { Route, Routes, BrowserRouter } from "react-router-dom";
import React, { Suspense, useEffect } from "react";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import LoginVerify from "../pages/LoginVerify";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationNum,
  getProfileDetails,
  loginWithPassword,
  refreshToken2,
} from "../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import GYM from "../pages/GYM";
import Mealdiet from "../pages/Mealdiet";
import AppDownload from "../pages/AppDownload";
import FastingPlan from "../pages/Fasting/FastingSetup/FastingPlan";
import FastingSetup from "../pages/Fasting/FastingSetup/FastingSetup";
import FastingSchedule from "../pages/Fasting/FastingSetup/FastingSchedule";
import GoodRead from "../pages/GoodRead";
import GoodReadTopic from "../pages/GoodRead/GoodReadTopic";
import GoodReadFullArticle from "../pages/GoodRead/GoodReadFullArticle";
import GymCategories from "../pages/Gym/GymCategories";
import MealCategory from "../pages/Meal/MealCategories";
import CustomMealList from "../pages/Meal/CustomMealList";
import CreateCustomMeal from "../pages/Meal/CreateCustomMeal";
import PricePlan from "../pages/Payment/PricePlan";
import FastingTrack from "../pages/Track/FastingTrack";
import TrackMenu from "../pages/TrackMenu";
import WorkoutTrack from "../pages/Track/WorkoutTrack";
import HealthTrack from "../pages/Track/HealthTrack";
import EatTrack from "../pages/Track/EatTrack";
import WaterTrack from "../pages/Track/WaterTrack";
import WorkoutTargetZone from "../pages/Gym/WorkoutTargetZone";
import MealCenterView from "../pages/Meal/MealCenterView";
import GymCenterView from "../pages/Gym/GymCenterView";
import PayResponse from "../pages/Payment/PayResponse";
import HealthTrackDetails from "../pages/Track/HealthTrackDetails";
import LoginWithPass from "../pages/LoginWithPass";

const AppRoute = () => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.webUtilities);

  useEffect(() => {
    const tokenRefreshInterval = setInterval(() => {
      dispatch(refreshToken2());
    }, 20 * 60 * 1000);
    return () => clearInterval(tokenRefreshInterval);
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      if (
        window.location.pathname !== "/login" &&
        window.location.pathname !== "/loginverfiy" &&
        window.location.pathname !== "/login-with-pass"
      ) {
        window.location.href = "/login";
      }
    } else {
      if (secureLocalStorage.getItem("refreshToken")) {
        // dispatch(refreshToken2());
      }
      if (!secureLocalStorage.getItem("profileDetails")) {
        dispatch(getProfileDetails());
      }
    }
    // dispatch(loginWithPassword());
    // dispatch(getNotificationNum());
  }, []);

  return (
    <BrowserRouter basename="/">
      <Suspense fallback={"Loading..."}>
        {isLoggedIn || isLoggedIn === "true" ? (
          <Routes>
            {/* Module 1 */}
            <Route path="/payment-pending" element={<PricePlan />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/fasting/setup/plan" element={<FastingPlan />} />
            <Route path="/fasting/setup/setup" element={<FastingSetup />} />
            <Route
              path="/fasting/setup/schedule"
              element={<FastingSchedule />}
            />

            {/* Module 2 */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Module 3 */}
            <Route path="/gym" element={<GYM />} />
            <Route path="/gym/:type/:category" element={<GymCategories />} />
            <Route path="/gym/target-zone" element={<WorkoutTargetZone />} />
            <Route path="/meal/:type/:category" element={<MealCategory />} />
            <Route path="/gym/gym-view" element={<GymCenterView />} />

            {/* Module 4 */}
            <Route path="/good-read" element={<GoodRead />} />
            <Route
              path="/good-read-topics/:type/:category"
              element={<GoodReadTopic />}
            />
            <Route
              path="/good-read/article/:id"
              element={<GoodReadFullArticle />}
            />

            {/* Module 5 */}
            <Route path="/mealdiet" element={<Mealdiet />} />
            <Route
              path="/mealdiet/custom/:type/:category"
              element={<CustomMealList />}
            />
            <Route
              path="/mealdiet/custom/create/:category"
              element={<CreateCustomMeal />}
            />
            <Route path="/mealdiet/meal-view" element={<MealCenterView />} />

            {/* Module 6 */}
            <Route path="/track/menu" element={<TrackMenu />} />
            <Route path="/track/fasting" element={<FastingTrack />} />
            <Route path="/track/workout" element={<WorkoutTrack />} />
            <Route path="/track/calorie" element={<EatTrack />} />
            <Route path="/track/water" element={<WaterTrack />} />
            <Route path="/track/health" element={<HealthTrack />} />
            <Route
              path="/track/health/details"
              element={<HealthTrackDetails />}
            />

            <Route path="/app-download" element={<AppDownload />} />
            <Route
              exact
              path="/callback/pg/:pgname/:getTranId"
              element={<PayResponse />}
            />
          </Routes>
        ) : (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/login-with-pass" element={<LoginWithPass />} />
            <Route path="/loginverfiy" element={<LoginVerify />} />
          </Routes>
        )}
      </Suspense>
    </BrowserRouter>
  );
};
export default AppRoute;
